"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addDisplayNameToPackage;

var _packageTemplates = _interopRequireDefault(require("../constants/packageTemplates"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CUSTOM_SUFFIX = ' (CUSTOM)';

function addDisplayNameToPackage(subPackage) {
  if (!subPackage) {
    return subPackage;
  }

  var templatedFrom = _packageTemplates.default.find(function (template) {
    return subPackage && template.name === subPackage.templatedFrom;
  });

  return _objectSpread({}, subPackage, {
    // $FlowFixMe templatedFrom packages always have a display name
    displayName: "".concat(templatedFrom.displayName).concat(subPackage.custom ? CUSTOM_SUFFIX : '')
  });
}